import type { CharacterElementTaskStatus } from '../types';

const runningStatuses: CharacterElementTaskStatus[] = [
  'created',
  'queueing',
  'preparation',
  'scheduling',
  'processing',
];

export const shouldPollCharacterElementTask = (status?: CharacterElementTaskStatus): boolean =>
  !status || runningStatuses.includes(status);

export const shouldRefreshCharacterElements = (status?: CharacterElementTaskStatus): boolean =>
  status === 'success' || status === 'failed' || status === 'canceled';
